import React, { useState, useEffect } from 'react';
import axios from '../../../utils/axios';
import { TextField, Button, Grid, Container } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import Footer from '../../Partial/footer/footer';
import Navbar from '../../Partial/navbar/Navbar';

const EditDealForm = () => {
  const { id } = useParams(); // Extract the dealId from the URL params
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [content, setContent] = useState('');
  const [imageLink, setImageLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch the current deal details when the component loads
    const fetchDeal = async () => {
      try {
        const response = await axios.get(`/deals/${id}`);
        const { title, description, content, imageLink } = response.data;
        setTitle(title);
        setDescription(description);
        setContent(content);
        setImageLink(imageLink);
      } catch (error) {
        setError('Failed to fetch the deal.');
        console.error('Error fetching deal:', error);
      }
    };

    fetchDeal();
  }, [id]); // Re-run the effect if dealId changes

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const updatedDeal = { title, description, imageLink, content };

    try {
      const response = await axios.put(`/deals/${id}`, updatedDeal);
      if (response.data) {
        // Navigate back to the updated deal's detail page
        navigate(`/discover/deal/${id}`); // Correct path
      }
    } catch (error) {
      setError('Error updating deal');
      console.error('Error updating deal:', error);
    } finally {
      setLoading(false);
    }
  };
  // Cancel and navigate back without saving
  const handleCancel = () => {
    navigate(`/discover/deal/${id}`); // Navigate to the deal detail page without saving changes
  };
  // Delete 1 deal
  const handleDelete = async () => {
    try {
      setLoading(true);
      await axios.delete(`/deals/${id}`);
      navigate('/discover'); // Navigate to the "discover" page or deals list after deletion
    } catch (error) {
      setError('Error deleting deal');
      console.error('Error deleting deal:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Navbar />
      <div className="container-fluid">
        <h2>Edit Post</h2>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Title"
                fullWidth
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Description"
                fullWidth
                multiline
                rows={4}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Content"
                fullWidth
                multiline
                rows={4}
                value={content}
                onChange={(e) => setContent(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Image Link"
                fullWidth
                value={imageLink}
                onChange={(e) => setImageLink(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="primary" disabled={loading}>
                {loading ? 'Saving...' : 'Save Changes'}
              </Button>
              <Button
                variant="outlined"
                onClick={handleCancel}
                style={{ marginLeft: '10px' }}
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={handleDelete}
                style={{ marginLeft: '10px' }}
                disabled={loading}
              >
                {loading ? 'Deleting...' : 'Delete'}
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
      <Footer />
    </Container>
  );
};

export default EditDealForm;